<template>
    <div>
        <h1>Add Data Conversion Summary To Be Implemented</h1>
    </div>
</template>

<script>
export default {
    name: 'NewDataTransformation',
    data() {
        return {

        }
    }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>